import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tagged_text = _resolveComponent("tagged-text");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_SegmentFilterBody = _resolveComponent("SegmentFilterBody");
  const _component_FilterItem = _resolveComponent("FilterItem");
  return _openBlock(), _createBlock(_component_FilterItem, {
    id: "segments",
    ref: "segmentFilterItem",
    class: "segment-filter",
    selectedTitle: $options.getSegmentsSelectedTitle,
    selectedCount: $props.segments?.filterState?.selectedCount,
    onClearAll: $options.handleClearAll,
    onApply: _cache[3] || (_cache[3] = $event => _ctx.$emit('apply')),
    onHidden: $options.onHidden
  }, {
    title: _withCtx(() => [$props.segments.selectedValues.length === 0 ? (_openBlock(), _createBlock(_component_tagged_text, {
      key: 0
    }, {
      default: _withCtx(() => [_createTextVNode("Segment")]),
      _: 1
    })) : (_openBlock(), _createBlock(_component_flex_row, {
      key: 1,
      gap: 4
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.segments?.filterState?.selected, ({
        id,
        segment
      }) => {
        return _openBlock(), _createBlock(_component_tagged_text, {
          key: id
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(segment), 1)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    }))]),
    body: _withCtx(() => [_createVNode(_component_SegmentFilterBody, {
      title: "Segments",
      selected: $props.segments?.filterState?.selected,
      isModified: $props.segments.isModified,
      pendingChanges: $props.segments.pendingChanges,
      isSearching: $props.segments.isSearching,
      keyword: $props.segments.keyword,
      list: $props.segments.displayList,
      onClear: $options.handleClear,
      onDiscard: $options.onDiscard,
      onRestoreSearch: $options.onRestoreSearch,
      onSelect: $options.handleSelect,
      onSelectOnly: $options.handleSelectOnly,
      onSelectAll: _cache[0] || (_cache[0] = $event => $props.segments.selectAll()),
      onDeselect: $options.handleDeselect,
      onApply: _cache[1] || (_cache[1] = $event => _ctx.$emit('apply')),
      onSearch: $options.handleSearch,
      onHidden: $options.onHidden,
      onCloseDropdown: _cache[2] || (_cache[2] = $event => _ctx.$refs?.segmentFilterItem?.closeDropdown())
    }, {
      empty: _withCtx(() => [_renderSlot(_ctx.$slots, "empty")]),
      _: 3
    }, 8, ["selected", "isModified", "pendingChanges", "isSearching", "keyword", "list", "onClear", "onDiscard", "onRestoreSearch", "onSelect", "onSelectOnly", "onDeselect", "onSearch", "onHidden"])]),
    _: 3
  }, 8, ["selectedTitle", "selectedCount", "onClearAll", "onHidden"]);
}